import { axios } from '@/request/http' // 导入http中创建的axios实例ccept: 'application/json, text/javascript, */*; q=0.01'
//提交测试
// 环境切换
// console.log(`process.env.NODE_ENV = ${process.env.NODE_ENV}`);
axios.defaults.baseURL = '/'
//解码
function getparams(params) {
    if (!params) {
        return
    } else {
        if (params.hasOwnProperty('sourceplat')) {
            // params.sourceplat = '1023'
        }
        return 'model=' + encodeURIComponent(JSON.stringify(params))
    }
}

const api = {
    // 例子:qq: (a) => axios.get('admin/domain/list',{params: a}),
    // 例子:ww: (a) => axios.post('admin/domain/edit', a),
    login: {
        // 用户登录
        USER_LOGIN: async params => {
            return await axios.post('/api/?d=admin&c=adminuser&m=dologin', getparams(params))
        }, // 用户退出
        USER_LOGOT: async () => {
            return await axios.post('/api/?d=admin&c=adminuser&m=dologout')
        }
    },
    administratorManagement: {
        // 管理员列表
        getAdminuserList: async params => {
            return await axios.get(`/api/?d=admin&c=adminuser&m=getlists`, { params })
        },
        // 重置管理员密码
        initAdminUserPW: async data => {
            return await axios.post('/api/?d=admin&c=adminuser&m=initadminuserpw', getparams(data))
        },
        // 删除管理员
        deleteAdminUser: async data => {
            return await axios.post('/api/?d=admin&c=adminuser&m=deleteadminuser', getparams(data))
        },
        // 账号冻结、解冻
        setAdminuSerLock: async data => {
            return await axios.post('/api/?d=admin&c=adminuser&m=setadminuserLock', getparams(data))
        },
        // 解绑GA
        cleargoogleauth: async data => {
            return await axios.post('/api/?d=admin&c=adminuser&m=cleargoogleauth', getparams(data))
        }
    },
    userManagement: {
        // 用户列表
        getUserLists: async data => {
            return await axios.post(`/api/?c=user&m=getlists&d=admin`, getparams(data))
        },
        // 用户详情
        getUserDetail: async data => {
            return await axios.post(`/api/?c=user&m=getuserdetail&d=admin`, getparams(data))
        },
        // 用户基本信息
        getUserBaseInfo: async data => {
            return await axios.post(`/api/?d=admin&c=user&m=getuserinfobyuid`, getparams(data))
        },
        // 更新用户基本信息
        updateUserBaseInfo: async data => {
            return await axios.post(`/api/?d=admin&c=user&m=updateuserrealinfo`, getparams(data))
        },
        // 手机验证码列表
        getvalidatesmslists: async data => {
            return await axios.post(`/api/?c=tele&m=getvalidatesmslists&d=admin`, getparams(data))
        },
        viewAliPayPlainText: params => {
            return axios.post(`/api/?d=admin&c=user&m=viewAliPayPlainText`, getparams(params)) //获取用户完整支付宝卡号
        },
        viewUSDTPlainText: params => {
            return axios.post(`/api/?d=admin&c=user&m=viewUSDTPlainText`, getparams(params)) //获取用户完整usdt卡号
        },
        viewECNYPlainText: params => {
            return axios.post(`/api/?d=admin&c=user&m=viewECNYPlainText`, getparams(params)) //获取用户完整数字人民币
        },
        viewKPlusPlainText: params => {
            return axios.post(`/api/?d=admin&c=user&m=viewKPlusPlainText`, getparams(params)) //获取用户完整kplus卡号
        },
        viewKKPlainText: params => {
            return axios.post(`/api/?d=admin&c=user&m=viewKKPlainText`, getparams(params)) //获取用户完整kk卡号
        },
        viewWechatPlainText: params => {
            return axios.post(`/api/?d=admin&c=user&m=viewWechatPlainText`, getparams(params)) //获取用户完整微信
        },
        viewBankCardPlainText: params => {
            return axios.post(`/api/?d=admin&c=user&m=viewBankCardPlainText`, getparams(params)) //获取用户完整银行卡
        }
    },
    usdt: {
        // 用户银行卡列表
        usdtdroporder: async data => {
            return await axios.post(`/api/?d=admin&c=usdtdroporder&m=getlists`, getparams(data)) //usdt掉单
        }
    },
    user: {
        UPLOAD_QRCODE_IMG: params => {
            return axios.post(`/api/?c=bankcard&m=uploadqrcodeimg&d=admin`, params) // 二维码上传
        },
        BANK_CARD_DETAIL: params => {
            return axios.post(`/api/?c=bankcard&m=getcarddetail&d=admin`, getparams(params)) //提现银行卡详情
        },
        SET_BLACK_CARD: params => {
            return axios.post(`/api/?d=admin&c=bankcard&m=setblackcard`, getparams(params)) //设置用户银行卡异常
        },
        ADD_BANKCARD: params => {
            return axios.post(`/api/?d=admin&c=bankcard&m=createbankcard`, getparams(params)) //添加银行卡
        },
        EDIT_BANKCARD: params => {
            return axios.post(`/api/?d=admin&c=bankcard&m=editcard`, getparams(params)) // 编辑银行卡
        },
        GET_EDITBANKINFO: params => {
            return axios.post(`/api/?c=bankcard&m=getcardeditinfo&d=admin`, getparams(params)) // 获取编辑银行卡信息
        },
        RESTORE_BANK_CARD: params => {
            return axios.post(`/api/?d=admin&c=bankcard&m=restorebindcard`, getparams(params)) //恢复绑定银行卡
        },
        DELETE_BANK_CARD: params => {
            return axios.post(`/api/?d=admin&c=bankcard&m=deletecard`, getparams(params)) //删除提现银行卡
        },
        UNBIND_BANK_CARD: params => {
            return axios.post(`/api/?d=admin&c=bankcard&m=unbindcard`, getparams(params)) //解绑提现银行卡
        },
        ALL_BANK_LIST: () => {
            return axios.get(`/api/?c=bankcard&m=getbanknonlists&d=admin`) // 获取所有银行列表
        },
        getbankcard: async data => {
            return await axios.post(`/api/?c=bankcard&m=getlists&d=admin`, getparams(data)) //用户银行卡
        }
    }
}

export default api
